import { render, staticRenderFns } from "./NotaIngresoUrpa.vue?vue&type=template&id=2a5e2ebb&scoped=true"
import script from "./NotaIngresoUrpa.vue?vue&type=script&lang=js"
export * from "./NotaIngresoUrpa.vue?vue&type=script&lang=js"
import style0 from "./NotaIngresoUrpa.vue?vue&type=style&index=0&id=2a5e2ebb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5e2ebb",
  null
  
)

export default component.exports